<div class="transcript-wrapper">
  @for (paragraph of paragraphs; track $index) {
    <div
      class="paragraph"
      [attr.data-owner]="paragraph.channel === EChannel.agent ? agentName : userName"
      [ngClass]="paragraph.channel === EChannel.agent ? 'agent' : 'user'"
    >
      {{ paragraph.paragraph }}
    </div>
  }
</div>
